import axios from 'axios';
import pinboardApi from '@/api/v1/pinboard';
import VueCookies from 'vue-cookies'

// URL and endpoint constants
// Auth
const SIGNUP_URL = '/account'; // POST
const LOGIN_URL = '/account/login'; // POST
const LOGOUT_URL = '/account/logout'; // PUT
const CANCEL_REGISTRATION_URL = '/account/cancel'; // DELETE, account can't be confirmed!
const RESEND_EMAIL_URL = '/account/resend_email'; // GET
// Other
const SHOW_PROFILE_URL = '/account/profile'; // GET
const ENABLE_EMAIL_NOTIFICATIONS = '/account/enable_email'; // PUT

const parent = () => VueCookies.get('is-parent') === 'true';

const getStorage = () => { return parent() ? sessionStorage : localStorage; }; // eslint-disable-line

export default {
  // Currently logged in user
  user: {
    authenticated: !! VueCookies.get('mogree-Access-Id'),
    confirmed: localStorage.getItem('User-Confirmed') === 'true',
    accessId: VueCookies.get('mogree-Access-Id'),
    pinboard: localStorage.getItem('Pinboard-Id'), // for testing: 672459
    name: VueCookies.get('User-Name'),
    item_id: VueCookies.get('Item-Id'),
    child: localStorage.getItem('Child-Code'),
    parent: VueCookies.get('is-parent') === 'true',
    role: VueCookies.get('is-parent') === 'true' ? 'eltern' : 'lehrer',
    getPinboard: () => localStorage.getItem('Pinboard-Id'),
    isParent: () => VueCookies.get('is-parent') === 'true', // preferred over using parent property
    isConfirmed: () => localStorage.getItem('User-Confirmed') === 'true', // preferred over using confirmed property
    isAuthenticated: () => !!VueCookies.get('mogree-Access-Id'), // preferred over using confirmed property
  },

  async setAuthHeaders(response, isParent, pinboardId) {
    const [userId, authToken, email, confirmed, itemid] =
        [response.userid, response.auth_token, response.userdata.mail, response.userdata.validated, response.itemid];
    const name = `${response.userdata.firstname} ${response.userdata.lastname}`;
    axios.defaults.headers.common['mogree-Access-Id'] = userId;

    this.user.authenticated = true;

    localStorage.setItem('User-Confirmed', confirmed);
    // Parent should authenticate again after session ends
    const dataStorage = isParent ? sessionStorage : localStorage;
    VueCookies.set('mogree-Access-Id',userId, null, null, null, true);

    VueCookies.set('is-parent', isParent, null, null, null, true);

    VueCookies.set('User-Name',name, null, null, null,true);
    VueCookies.set('User-Email',email, null, null, null,true);
    localStorage.setItem('Pinboard-Id', pinboardId);
    VueCookies.set('Item-Id',itemid, null, null, null,true);
  },

  removeAuthHeaders() {
    const translateTarget = localStorage.getItem('translateTarget');
    localStorage.clear();
    sessionStorage.clear();
    VueCookies.remove('is-parent');
    VueCookies.remove('Item-Id');
    VueCookies.remove('User-Email');
    VueCookies.remove('mogree-Access-Id');
    VueCookies.remove('email');

    localStorage.setItem('translateTarget', translateTarget);

    delete axios.defaults.headers.common['mogree-Access-Id'];
  },

  setDefaultPinboard(succ) {
    pinboardApi.index((data) => {
      if (data.listresponse.length) {
        localStorage.setItem('Pinboard-Id', data.listresponse[0].itemid);
        localStorage.setItem('Child-Code', data.listresponse[0].code);
        succ();
      } else {
        location.href = '#/deactivated';
      }
    });
  },

  // Send a request to the login URL and save returned JWT. This request has to send params in url.
  parentLogin(params, succ, err) {
    this.removeAuthHeaders();

    axios.defaults.headers.common['mail'] = params['mail'];
    axios.defaults.headers.common['password'] =params['password'];
    axios.defaults.headers.common['Access-Control-Allow-Headers'] = "Content-Type, Authorisation";


    axios.post(LOGIN_URL, {}, {teacher:params['teacher']  }).then((response) => {
      console.log(response);
      const detailResponse = response.data.detailresponse;
      const isParent = true;

      if (response.data.statuscode !== 200) throw response;
      // if login is successful but user is not verified yet, throw an error
      if (!detailResponse.userdata.validated) {
        this.setAuthHeaders(detailResponse, isParent);
        throw response;
      }

      this.setAuthHeaders(detailResponse, isParent).then(() => {
        succ(response);
        // Fetch pinboard list and set first item as default pinboard, reload page
        this.setDefaultPinboard(() => {
          location.href = '';
        });
      });
    }).catch((response) => {
      err(response);
    });
  },

  // Only for teacher.
  // Endpoint is accessable only from the same server and can be handled only by server-side script
  shibboleth(user, pinboardId, succ, err) {
    axios.post('accountweb/login/shibboleth', user).then((response) => {
      if (response.data.statuscode !== 200) throw response;

      const detailResponse = response.data.detailresponse;
      const isParent = false;

      this.setAuthHeaders(detailResponse, isParent, pinboardId).then(() => {
        succ(response);
        location.href = '';
      });
    }).catch((response) => {
      err(response.data);
    });
  },

  // Send a request to the login URL and save the returned JWT
  signup(user, succ, err) {
    delete axios.defaults.headers.common['mogree-Access-Id'];

    axios.post(SIGNUP_URL, user, { params: { code: user.code } }).then((response) => {
      if (response.data.statuscode !== 200) throw response;

      const detailResponse = response.data.detailresponse;
      const isParent = true;

      this.setAuthHeaders(detailResponse, isParent).then(() => {
        succ(response);
      });
    }).catch((response) => {
      err(response.data);
    });
  },

  logoff(succ, err) {

    axios.put(LOGOUT_URL, {
      params: {
        "mogree-Access-Id"    : this.user.accessId
      }
    }).then((response) => {
      if (response.data.statuscode !== 200) throw response;

      const detailResponse = response.data.detailresponse;
      console.log(JSON.stringify(detailResponse, null, 2))
      const isParent = true;

    }).catch((response) => {
      err(response.data);
    });
  },

  cancelRegistration(succ) {
    return axios.delete(CANCEL_REGISTRATION_URL).then((response) => {
      succ(response.data);
    });
  },

  resendEmail(succ) {
    axios.get(RESEND_EMAIL_URL).then((response) => {
      succ(response.data);
    });
  },

  show(succ) {
    axios.get(SHOW_PROFILE_URL).then((response) => {
      succ(response.data);
    });
  },

  enableEmailNotifications(enabled) {
    return axios.put(ENABLE_EMAIL_NOTIFICATIONS, {}, { params: { enabled } });
  },

  // remove the token to log out
  logout() {
    this.logoff();
    this.removeAuthHeaders();
    if (!this.user.parent) location.href = process.env.SSO_LOGOUT_URL;
    else location.reload();
  },
};



// WEBPACK FOOTER //
// ./src/api/v1/account.js